import { getHttpApi } from '@cian/http-api/browser';
import { getLogger } from '@cian/logger/browser';
import {
  fetchGetInfrastructureNearbyBlock,
  IGetInfrastructureNearbyBlockRequest,
  IGetInfrastructureNearbyBlockResponse,
  IGetInfrastructureNearbyBlockResponse200,
  IGetInfrastructureNearbyBlockResponse400,
} from '../../../repositories/price-estimator/v2/get-infrastructure-nearby-block';
import { BadRequestError } from '@cian/valuation-utils-component';

export const onInfrastructureObjectsFetch = async ({
  address,
}: IGetInfrastructureNearbyBlockRequest): Promise<IGetInfrastructureNearbyBlockResponse> => {
  try {
    const response = await fetchGetInfrastructureNearbyBlock<
      IGetInfrastructureNearbyBlockResponse200,
      IGetInfrastructureNearbyBlockResponse400
    >({
      httpApi: getHttpApi(),
      parameters: {
        address,
      },
      config: {
        requestConfig: { withCredentials: true },
      },
    });

    if (response.statusCode !== 200) {
      throw new BadRequestError({
        domain: 'onInfrastructureObjectsFetch.ts',
        message: response.response.message as string,
        details: { errors: JSON.stringify(response.response.errors) },
      });
    }

    return response.response as IGetInfrastructureNearbyBlockResponse;
  } catch (err) {
    getLogger().error(err);

    return {
      infrastructure: undefined,
      metro: [],
      roads: [],
    };
  }
};
